import React from "react";
import PropTypes from "prop-types";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Form, Input } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';

const db = getDatabase(Firebase);

const CountriesActionLayout = (props) => {
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));

	const handleCreate = (values) => {
		const id = uuidv4();
		const payload = {
			id,
			count: 0,
			alpha3Code: values.alpha3Code.toUpperCase(),
			countryName: values.country,
			capital: values.capital
		};
		props.createCallback("countries", id, payload);
	};

	const validateCountryUnique = ({ getFieldValue }) => ({
		validator(_, value) {
			if (!value) return Promise.resolve();

			const countryName = getFieldValue('country');
			const alpha3Code = getFieldValue('alpha3Code');

			if (!countryName || !alpha3Code) return Promise.resolve();

			const exists = countries.some(
				x => x.alpha3Code.toLowerCase() === alpha3Code.toLowerCase() &&
					x.name.toLowerCase() === countryName.toLowerCase()
			);

			if (exists) {
				return Promise.reject('This country already exists!');
			}
			return Promise.resolve();
		},
	});

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol>
					<Form layout="vertical" onFinish={handleCreate}>
						<Form.Item
							label="Enter country name"
							name="country"
							rules={[{ required: true, message: 'Please input country name!' }]}
							className="d-flex flex-column my-2 mt-3"
						>
							<Input
								className="w-100"
								placeholder="Enter country name"
							/>
						</Form.Item>

						<Form.Item
							label="Enter Country's 3 letter alpha Code"
							name="alpha3Code"
							rules={[
								{ required: true, message: 'Please input alpha code!' },
								{ max: 3, message: 'Code must be maximum 3 characters' },
								{
									pattern: /^[A-Za-z]+$/,
									message: "Field only accepts letters"
								},
								validateCountryUnique
							]}
							className="d-flex flex-column my-2 mt-3"
						>
							<Input
								className="w-100"
								placeholder="Enter country code (e.g. USA)"
								maxLength={3}
							/>
						</Form.Item>

						<Form.Item
							label="Enter country capital"
							name="capital"
							className="d-flex flex-column my-2"
						>
							<Input
								className="w-100"
								placeholder="Enter capital"
							/>
						</Form.Item>

						<Button appearance="primary" htmlType="submit" className="mt-2">
							Add
						</Button>
					</Form>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

CountriesActionLayout.propTypes = {
	createCallback: PropTypes.func.isRequired
};

export default CountriesActionLayout;